import { createSelector } from 'reselect';
import basketSelector from 'selectors/basket/basketSelector';
import { hasSameDayItemsSelector } from 'selectors/basket/hasSameDayItemsSelector';
import { showGuestCheckoutForBopisAndSddAbTestSelector } from 'viewModel/selectors/testTarget/showGuestCheckoutForBopisAndSddAbTestSelector';

const isGuestCheckoutEnabledSelector = createSelector(
    basketSelector,
    hasSameDayItemsSelector,
    showGuestCheckoutForBopisAndSddAbTestSelector,
    (basket, hasSameDayItems, showGuestCheckoutForBopisAndSddAbTest) => {
        const isEnabledInBasket = basket?.isGuestCheckoutEnabled || false;

        // When the A/B test is off, don't let SDD baskets fall through the generic guest-checkout killswitch —
        // the SDD experience is what the A/B test is meant to gate, so opt those users out even if the backend flag is on.
        if (isEnabledInBasket && !showGuestCheckoutForBopisAndSddAbTest && hasSameDayItems) {
            return false;
        }

        return isEnabledInBasket;
    }
);

export { isGuestCheckoutEnabledSelector };
